module.exports = new __parcel__URL__("choose_1.7042b295.png").toString();